import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService, ToastConfig } from '../../../../core/services/toast.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { Subscription } from 'rxjs';
// import { Toast } from '../../../../models/toast.model' /models/toast.model';
@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [
    trigger('toastAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('300ms ease-in-out', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in-out', style({ transform: 'translateX(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class ToastComponent implements OnInit, OnDestroy {
  toasts$ = this.toastService.toasts$;
  private toastSubscription?: Subscription;
  private autoCloseTimers: Map<string, any> = new Map();

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.toastSubscription = this.toasts$.subscribe((toasts: ToastConfig[]) => {
      toasts.forEach((toast: ToastConfig) => {
        if (toast.duration && toast.id && !this.autoCloseTimers.has(toast.id)) {
          const timer = setTimeout(() => {
            if (toast.id) {
              this.removeToast(toast.id);
            }
          }, toast.duration);
          this.autoCloseTimers.set(toast.id, timer);
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.toastSubscription?.unsubscribe();
    this.autoCloseTimers.forEach(timer => clearTimeout(timer));
  }

  getIconClass(type: ToastConfig['type']): string {
    switch (type) {
      case 'success': return 'bi bi-check-circle-fill';
      case 'error': return 'bi bi-x-circle-fill';
      case 'warning': return 'bi bi-exclamation-circle-fill';
      case 'info': return 'bi bi-info-circle-fill';
      default: return 'bi bi-info-circle-fill';
    }
  }

  removeToast(id?: string): void {
    if (!id) return;
    if (this.autoCloseTimers.has(id)) {
      clearTimeout(this.autoCloseTimers.get(id));
      this.autoCloseTimers.delete(id);
    }
    this.toastService.remove(id);
  }
}
